import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { CardText } from 'material-ui/Card';
import IconButton from 'material-ui/IconButton';
import ActionHide from 'material-ui/svg-icons/action/highlight-off';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import autoprefixer from 'material-ui/utils/autoprefixer';
import muiThemeable from 'material-ui/styles/muiThemeable';
import lodashSet from 'lodash.set';
import { BMTheme } from "../../BMTheme";

import translate from '../../admin-on-rest/src/i18n/translate';

const getStyles = ({ palette: { primary1Color } }) => ({
    card: {
        marginTop: '-14px',
        padding: '0 16px',
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
    },
    cardNested: {
        marginTop: '-14px',
        paddingTop: 0,
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'flex-end',
        flexWrap: 'wrap',
    },
    body: { display: 'flex', alignItems: 'center' },
    bodyNested: { display: 'flex', alignItems: 'flex-end' },
    spacer: { width: 48 },
    iconNested: { color: primary1Color || '#00bcd4', paddingBottom: 0 },
    icon: { color: `${BMTheme.icons.color}`, paddingBottom: 0 },
    clearFix: { clear: 'right' },
});

const emptyRecord = {};

export class FilterForm extends Component {
    getShownFilters() {
        const { filters, displayedFilters, initialValues } = this.props;
        return filters.filter(
            filterElement =>
                filterElement.props.alwaysOn ||
                displayedFilters[filterElement.props.source] ||
                typeof initialValues[filterElement.props.source] !== 'undefined'
        );
    }

    handleHide = event =>
        this.props.hideFilter(event.currentTarget.dataset.key);

    render() {
        const { resource, translate, muiTheme, isNested } = this.props;

        // Use a fake prefixer when none is returned. Useful for tests
        const prefix = autoprefixer(muiTheme) || (style => style);
        const styles = getStyles(muiTheme);

        return (
            isNested ? 
            <div>
                <CardText style={prefix(styles.cardNested)}>
                    {this.getShownFilters()
                        .reverse()
                        .map(filterElement => {
                            return(
                            <div
                                key={filterElement.props.source}
                                data-source={filterElement.props.source}
                                className="filter-field"
                                style={
                                    filterElement.props.style ||
                                    prefix(styles.bodyNested)
                                }
                            >
                                {filterElement.props.alwaysOn ? (
                                    <div style={prefix(styles.spacer)}>z
                                        &nbsp;
                                    </div>
                                ) : 
                                <IconButton
                                    iconStyle={prefix(styles.iconNested)}
                                    className="hide-filter"
                                    onClick={this.handleHide}
                                    data-key={filterElement.props.source}
                                    tooltip={translate(
                                        'aor.action.remove_filter'
                                    )}
                                >
                                    <ActionHide />
                                </IconButton>
                                }
                                <Field
                                    allowEmpty
                                    {...filterElement.props}
                                    name={filterElement.props.source}
                                    component={filterElement.type}
                                    resource={resource}
                                    record={emptyRecord}
                                /> 
                            </div> 
                        )})}
                </CardText>
                <div style={prefix(styles.clearFix)} />
            </div> :
            <div>
            <CardText style={prefix(styles.card)}>
                {this.getShownFilters()
                    .reverse()
                    .map(filterElement => {
                        return(
                        <div
                            key={filterElement.props.source}
                            data-source={filterElement.props.source}
                            className="filter-field"
                            style={
                                filterElement.props.style ||
                                prefix(styles.body)
                            }
                        >
                            {filterElement.props.alwaysOn ? (
                                <div style={prefix(styles.spacer)}>z
                                    &nbsp;
                                </div>
                            ) : 
                            <IconButton
                                iconStyle={prefix(styles.icon)}
                                className="hide-filter"
                                onClick={this.handleHide}
                                data-key={filterElement.props.source}
                                tooltip={translate(
                                    'aor.action.remove_filter'
                                )}
                            >
                                <ActionHide />
                            </IconButton>
                            }
                            <Field
                                allowEmpty
                                {...filterElement.props}
                                name={filterElement.props.source}
                                component={filterElement.type}
                                resource={resource}
                                record={emptyRecord}
                                labelStyle={{color: BMTheme.palette.alternateTextColor}}
                                inputStyle={{color: BMTheme.palette.alternateTextColor, marginTop: "7px"}}
                                floatingLabelStyle={{color: BMTheme.palette.alternateTextColor, top: "28px"}}
                                underlineStyle={{color: BMTheme.palette.alternateTextColor, borderBottom: "1px solid", bottom: "15px"}}
                                underlineShow={true}
                                underlineFocusStyle={{color: BMTheme.palette.alternateTextColor, borderBottom: "1px solid"}}
                                hintStyle={{color: BMTheme.palette.alternateTextColor}}
                            /> 
                        </div> 
                    )})}
            </CardText>
            <div style={prefix(styles.clearFix)} />
        </div>
        );
    }
}

FilterForm.propTypes = {
    resource: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.node).isRequired,
    displayedFilters: PropTypes.object.isRequired,
    hideFilter: PropTypes.func.isRequired,
    initialValues: PropTypes.object,
    translate: PropTypes.func.isRequired,
    muiTheme: PropTypes.object.isRequired,
};

export const mergeInitialValuesWithDefaultValues = ({
    initialValues,
    filters,
}) => ({
    initialValues: {
        ...filters
            .filter(
                filterElement =>
                    filterElement.props.alwaysOn &&
                    filterElement.props.defaultValue
            )
            .reduce(
                (acc, filterElement) =>
                    lodashSet(
                        { ...acc },
                        filterElement.props.source,
                        filterElement.props.defaultValue
                    ),
                {}
            ),
        ...initialValues,
    },
});

const enhance = compose(
    muiThemeable(),
    translate,
    withProps(mergeInitialValuesWithDefaultValues),
    reduxForm({
        form: 'filterForm',
        enableReinitialize: true,
        onChange: (values, dispatch, props) => props.setFilters(values),
    })
);

export default enhance(FilterForm);



// WEBPACK FOOTER //
// ./src/components/CRM/FilterForm.js